import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import {
  AuthForm,
  AuthPageWrapper,
  usernamePasswordFieldsDescription,
} from '@app/components';
import { useAuthentication } from '@app/hooks';
import { sharedMessages } from '@app/translations';
import { LOGIN_METHOD, PASSWORD_TYPE } from '@app/constants';

export const DirectLoginPage: FC = () => {
  const { $t } = useIntl();
  const { notification, isLoading, loginUser } = useAuthentication({
    method: LOGIN_METHOD.direct,
    passwordFieldName: PASSWORD_TYPE.password,
  });

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'login.documentTitle',
            defaultMessage: 'Login - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <AuthPageWrapper
        title={$t(sharedMessages.welcomeBack)}
        notification={notification}
      >
        <AuthForm
          fields={usernamePasswordFieldsDescription}
          isLoading={isLoading}
          onSubmit={loginUser}
        />
      </AuthPageWrapper>
    </>
  );
};
